import { render, staticRenderFns } from "./requestDetail.modal.vue?vue&type=template&id=9bb9e994"
import script from "./requestDetail.modal.vue?vue&type=script&lang=js"
export * from "./requestDetail.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports